// XXX: Use stubbed plans response until second plan is added to BOA
export default {
  plans: [
    {
      vertical: 'chubb_boa',
      id: '0285cc3d-2e01-4d9c-a214-c210cd473056',
      currency: 'USD',
      plan_type: 'chubb_boa',
      settings: {
        plan_title: 'Business Owners Accident Insurance',
        sample_policy_url: 'https://s3.amazonaws.com/POLICY_PROPOSAL_URL.pdf',
        details: {
          plan_type: 'chubb_boa',
          plan_name: 'boa',
          coverage_details: {
            business_owner_coverage: {
              primary_benefits: {
                business_owner_accidental_death_and_dismemberment: {
                  title: 'Accidental Death & Dismemberment',
                  description: [
                    {
                      title: 'Accidental',
                      value: '% of Principal Sum',
                    },
                    {
                      title: 'Loss of Life',
                      value: '100%',
                    },
                    {
                      title: 'Loss of Speech and Loss of Hearing',
                      value: '100%',
                    },
                    {
                      title:
                        'Loss of Speech and one of Loss of Hand, Loss of Foot or Loss of Sight of One Eye',
                      value: '100%',
                    },
                    {
                      title:
                        'Loss of Hearing and one of Loss of Hand, Loss of Foot or Loss of Sight of One Eye',
                      value: '100%',
                    },
                    {
                      title:
                        'Loss of Hands (Both), Loss of Feet (Both), Loss of Sight or a combination of any two of Loss of Hand, Loss of Foot or Loss of Sight of One Eye',
                      value: '100%',
                    },
                    {
                      title:
                        'Loss of Hand, Loss of Foot or Loss of Sight of One Eye (Any one of each)',
                      value: '50%',
                    },
                    {
                      title: 'Loss of Speech or Loss of Hearing',
                      value: '50%',
                    },
                    {
                      title: 'Loss of Thumb and Index Finger of the same hand',
                      value: '25%',
                    },
                  ],
                  coverage_details: ['24 Hour Business and Pleasure'],
                  value_details: ['Principal Sum - $500,000'],
                },
                business_owner_paralysis: {
                  title: 'Paralysis',
                  coverage_details: ['24 Hour Business and Pleasure'],
                  value_details: [
                    'Quadriplegia - 100% of Principal Sum',
                    'Paraplegia - 75% of Principal Sum',
                    'Hemiplegia - 50% of Principal Sum',
                    'Uniplegia - 25% of Principal Sum',
                  ],
                },
              },
              additional_benefits: {
                business_owner_cobra_premium_expense: {
                  title: 'Cobra Premium Expense',
                  description:
                    'In the event of a covered loss of life, this benefit pays up to $10,000 annually for the Insured Person’s Dependent who is COBRA eligible to continue group medical or group dental insurance under a plan provided through the Policyholder.',
                  coverage_details: ['24 Hour Business and Pleasure'],
                  value_details: ['$10,000'],
                },
                business_owner_permanent_total_disability: {
                  title: 'Permanent Total Disability',
                  description:
                    'Pays a benefit amount if a Felonious Assault resulting in an accidental bodily injury causes an insured person to suffer a disability that continues for 365 days and is expected to continue without interruption and without expectation of recovery for the rest of the insured’s life as determined by a physician.',
                  coverage_details: ['Felonious Assault'],
                  value_details: [
                    '1% of the Principal Sum (Monthly) to a maximum of $250,000',
                    'Elimination Period: 365 days',
                  ],
                },
                business_owner_temporary_total_disability: {
                  title: 'Temporary Total Disability',
                  description:
                    'In the event of a Felonious Assault the Insured Person is covered up to a total of $13,000 in Temporary Disability income if the injury causes them to miss work.',
                  coverage_details: ['Felonious Assault'],
                  value_details: [
                    '$500 per week',
                    'Maximum Benefit Period: 26 weeks',
                    'Elimination Period: 7 days',
                  ],
                },
                business_owner_enhanced_in_hospital: {
                  title: 'Enhanced In-Hospital',
                  description:
                    'Pays a daily benefit for each day an insured person is in the hospital as the result of an accident caused by a Felonious Assault.',
                  coverage_details: ['Felonious Assault'],
                  value_details: [
                    'Daily Benefit Amount: $500',
                    'Maximum Number of Days: 30',
                    'Elimination Period: 3 days',
                  ],
                },
              },
            },
            employee_coverage: {
              primary_benefits: {
                employee_accidental_death_and_dismemberment_assault: {
                  title: 'Accidental Death & Dismemberment',
                  description: [
                    {
                      title: 'Accidental',
                      value: '% of Principal Sum',
                    },
                    {
                      title: 'Loss of Life',
                      value: '100%',
                    },
                    {
                      title: 'Loss of Speech and Loss of Hearing',
                      value: '100%',
                    },
                    {
                      title:
                        'Loss of Speech and one of Loss of Hand, Loss of Foot or Loss of Sight of One Eye',
                      value: '100%',
                    },
                    {
                      title:
                        'Loss of Hearing and one of Loss of Hand, Loss of Foot or Loss of Sight of One Eye',
                      value: '100%',
                    },
                    {
                      title:
                        'Loss of Hands (Both), Loss of Feet (Both), Loss of Sight or a combination of any two of Loss of Hand, Loss of Foot or Loss of Sight of One Eye',
                      value: '100%',
                    },
                    {
                      title:
                        'Loss of Hand, Loss of Foot or Loss of Sight of One Eye (Any one of each)',
                      value: '50%',
                    },
                    {
                      title: 'Loss of Speech or Loss of Hearing',
                      value: '50%',
                    },
                    {
                      title: 'Loss of Thumb and Index Finger of the same hand',
                      value: '25%',
                    },
                  ],
                  coverage_details: ['Felonious Assault'],
                  value_details: ['Principal Sum - $250,000'],
                },
                employee_accidental_death_and_dismemberment_business: {
                  title: 'Accidental Death & Dismemberment',
                  description: [
                    {
                      title: 'Accidental',
                      value: '% of Principal Sum',
                    },
                    {
                      title: 'Loss of Life',
                      value: '100%',
                    },
                    {
                      title: 'Loss of Speech and Loss of Hearing',
                      value: '100%',
                    },
                    {
                      title:
                        'Loss of Speech and one of Loss of Hand, Loss of Foot or Loss of Sight of One Eye',
                      value: '100%',
                    },
                    {
                      title:
                        'Loss of Hearing and one of Loss of Hand, Loss of Foot or Loss of Sight of One Eye',
                      value: '100%',
                    },
                    {
                      title:
                        'Loss of Hands (Both), Loss of Feet (Both), Loss of Sight or a combination of any two of Loss of Hand, Loss of Foot or Loss of Sight of One Eye',
                      value: '100%',
                    },
                    {
                      title:
                        'Loss of Hand, Loss of Foot or Loss of Sight of One Eye (Any one of each)',
                      value: '50%',
                    },
                    {
                      title: 'Loss of Speech or Loss of Hearing',
                      value: '50%',
                    },
                    {
                      title: 'Loss of Thumb and Index Finger of the same hand',
                      value: '25%',
                    },
                  ],
                  coverage_details: ['24 Hour Business Travel'],
                  value_details: ['Principal Sum - $100,000'],
                },
                employee_paralysis: {
                  title: 'Paralysis',
                  coverage_details: [
                    'Felonious Assault',
                    '24 Hour Business Travel',
                  ],
                  value_details: [
                    'Quadriplegia - 100% of Principal Sum',
                    'Paraplegia - 75% of Principal Sum',
                    'Hemiplegia - 50% of Principal Sum',
                    'Uniplegia - 25% of Principal Sum',
                  ],
                },
              },
              additional_benefits: {
                employee_cobra_premium_expense: {
                  title: 'Cobra Premium Expense',
                  description:
                    'In the event of a covered loss of life, this benefit pays up to $10,000 annually for the Insured Person’s Dependent who is COBRA eligible to continue group medical or group dental insurance under a plan provided through the Policyholder.',
                  coverage_details: [
                    'Felonious Assault',
                    '24 Hour Business Travel',
                  ],
                  value_details: ['$10,000'],
                },
                employee_permanent_total_disability: {
                  title: 'Permanent Total Disability',
                  description:
                    'Pays a benefit amount if a Felonious Assault resulting in an accidental bodily injury causes an insured person to suffer a disability that continues for 365 days and is expected to continue without interruption and without expectation of recovery for the rest of the insured’s life as determined by a physician.',
                  coverage_details: ['Felonious Assault'],
                  value_details: [
                    '1% of the Principal Sum (Monthly) to a maximum of $250,000',
                    'Elimination Period: 365 days',
                  ],
                },
                employee_temporary_total_disability: {
                  title: 'Temporary Total Disability',
                  description:
                    'In the event of a Felonious Assault the Insured Person is covered up to a total of $13,000 in Temporary Disability income if the injury causes them to miss work.',
                  coverage_details: ['Felonious Assault'],
                  value_details: [
                    '$500 per week',
                    'Maximum Benefit Period: 26 weeks',
                    'Elimination Period: 7 days',
                  ],
                },
                employee_enhanced_in_hospital: {
                  title: 'Enhanced In-Hospital',
                  description:
                    'Pays a daily benefit for each day an insured person is in the hospital as the result of an accident caused by a Felonious Assault.',
                  coverage_details: ['Felonious Assault'],
                  value_details: [
                    'Daily Benefit Amount: $500',
                    'Maximum Number of Days: 30',
                    'Elimination Period: 3 days',
                  ],
                },
              },
            },
          },
        },
      },
    },
  ],
};
